import { useState, useEffect, useRef, useCallback } from "react";
import "../../pages/homepage.css";
import "./homepageEditor.css";
import Avatar4 from '../../Images/new_pic_4.png';
import Footer from '../../Component/NewFooter';
import Logo1 from '../../Images/partners/prt1.png';
import Logo2 from '../../Images/partners/prt2.png';
import Logo3 from '../../Images/partners/prt3.png';
import Logo4 from '../../Images/partners/prt4.png';
import Logo5 from '../../Images/partners/prt5.png';
import Logo6 from '../../Images/partners/prt6.png';
import Logo7 from '../../Images/partners/prt7.png';
import Logo8 from '../../Images/partners/prt8.png';
import Logo9 from '../../Images/partners/prt9.png';
import Logo10 from '../../Images/partners/prt10.png';
import Logo11 from '../../Images/partners/prt11.png';
import Slide1 from '../../Images/new_pic_1.png';
import Slide2 from '../../Images/s2.png';
import Slide3 from '../../Images/new_pic_2.png';
import Slide4 from '../../Images/s4.png';
import Slide5 from '../../Images/new_pic_3.jpeg';
import Slide6 from '../../Images/s6.jpeg';
import Aboutbg from '../../Images/jeysh.jpeg';
import {
  FaWrench, FaBoxOpen, FaHardHat,
  FaClipboardCheck, FaSatelliteDish, FaShip,
} from "react-icons/fa";

/* ─── API Config ─── */
const BASE_URL = "https://staging.pteshstudios.com";

const API_BASE = `${BASE_URL}/api/homepage`;
const UPLOAD_URL = `${BASE_URL}/api/upload`;
const SERVER_ORIGIN = BASE_URL;

/* ─── Static assets fallbacks ─── */
const LOCAL_HERO_BGS = [Slide1, Slide2, Slide3, Slide4, Slide5, Slide6];

const clients = [
  { name: "AGIP",          logo: Logo1 },
  { name: "Chevron",       logo: Logo2 },
  { name: "Shell",         logo: Logo3 },
  { name: "LNG Nigeria",   logo: Logo4 },
  { name: "TotalEnergies", logo: Logo5 },
  { name: "Lee Engineering", logo: Logo6 },
  { name: "NNPC",          logo: Logo7 },
  { name: "ExxonMobil",    logo: Logo8 },
  { name: "Partner 9",     logo: Logo9 },
  { name: "Partner 10",    logo: Logo10 },
  { name: "Partner 11",    logo: Logo11 },
];

/* ─── Default icons map for services (non-editable, display only) ─── */
const SERVICE_ICONS = [
  <FaWrench />, <FaBoxOpen />, <FaHardHat />,
  <FaClipboardCheck />, <FaSatelliteDish />, <FaShip />,
];

/* ─── Default page data ─── */
const DEFAULT_DATA = {
  heroSlides: [
    { title: "Driven by Innovation. Built on Integrity.",          bg: "" },
    { title: "Empowering Communities Through Energy.",             bg: "" },
    { title: "Integrated Energy Services, Proven Results.",        bg: "" },
    { title: "Local Strength. Global Standards.",                  bg: "" },
    { title: "Engineering Energy for Sustainable Growth.",         bg: "" },
    { title: "Excellence in Oil, Gas & Energy Services.",          bg: "" },
  ],
  announcement: "The reference point for true local content development in the oil & gas industry",
  about: {
    heading:    "We provide end-to-end project execution services",
    paragraph1: "Jeyshawn Engineering Limited was incorporated in 2012 with the CAC, Federal Republic of Nigeria with RC Number: 1026776. Jeyshawn Engineering Limited is a recognized indigenous EPCIC leader, delivering world-class engineering and project execution services across the oil & gas and energy sectors. Jeyshawn is known for safety, excellence, technical competence, strong governance and sustainable growth.",
    paragraph2: "With a track record of excellence, safety and innovations, Jeyshawn Engineering Limited provides end-to-end project execution services, ensuring timely delivery and operational efficiency for complex industrial projects.",
    paragraph3: "Our multi-disciplinary team of professionals brings deep industry expertise and technical know-how to deliver value-driven solutions that meets global standards.",
    statHours:   "105,120",
    statHoursLabel: "Man Hours With Zero Fatality",
    statProjects: "23",
    statProjectsLabel: "With 100% Completion Rate",
    image: "",
    videoUrl: "https://www.youtube.com/embed/Q4CUwOb0_3Y?autoplay=1",
  },
  servicesSection: {
    title: "What We Do",
  },
  services: [
    { title: "Engineering",   desc: "We bring together experienced engineers, project managers, and technical experts who are passionate about solving complex engineering challenges and delivering long-lasting solutions.", href: "/engineering" },
    { title: "Procurement",   desc: "Our Procurement Services are designed to ensure timely, cost-efficient, and quality-assured sourcing of materials, equipment, and services essential for project success.", href: "/procurement" },
    { title: "Construction",  desc: "We deliver high-quality, safe, and efficient solutions across a wide range of sectors, including oil & gas, infrastructure, energy, and industrial facilities.", href: "/construction" },
    { title: "Commissioning", desc: "Comprehensive commissioning services ensuring all systems and equipment are tested, verified, and fully operational before handover, meeting all technical specifications.", href: "/commissioning" },
    { title: "Installation and Instrumentation", desc: "Expert installation services for complex equipment and systems, ensuring precise execution, safety compliance, and seamless integration with existing infrastructure.", href: "/installation" },
    { title: "Marine Support", desc: "Specialized marine support services providing offshore logistics, vessel operations, and maritime technical solutions for oil & gas operations in challenging environments.", href: "/marine-support" },
  ],
  clientsSection: {
    title: "Our Clients",
    subtitle: "At Jeyshawn Engineering Limited, we build lasting partnerships based on trust, integrity and performance. our clients rely on us for innovative engineering solutions. executed with a strong commitment to safety, quality and excellence. Together, we deliver projects that drive operational success and sustainable value.",
  },
  coreValues: {
    label:   "Core Values",
    heading: "Here are the values that drive us",
    items: [
      { name: "Professionalism", desc: "At Jeyshawn Engineering Limited, professionalism defines how we operate and interact with our clients, partners, and host communities. We uphold the highest standards of competence, discipline, respect, and ethical conduct in every aspect of our operations." },
      { name: "Accountability",  desc: "We take full ownership of our responsibilities, commitments, and project outcomes. Accountability is at the heart of our operations, driving us to deliver on our promises with transparency, reliability, and consistency." },
      { name: "Excellence",      desc: "We are committed to achieving excellence in everything we do. Through continuous improvement, innovation, and adherence to global industry standards and best practices, we consistently deliver high-quality engineering solutions that exceed clients' expectations." },
      { name: "Leadership",      desc: "We lead with vision and purpose. Our leadership culture inspires teamwork, innovation, and boost employees' confidence while empowering our workforce to achieve outstanding results." },
      { name: "Integrity",       desc: "Integrity is the foundation of our business. We conduct all operations with honesty, fairness, transparency, and ethical responsibility, building trust through responsible actions, open communication, and unwavering professional standards." },
      { name: "Teamwork",        desc: "We believe collaboration is essential for organisational success. Our strength lies in the ability of our team to work together across different disciplines, combining skills, experience, and ideas to achieve shared goals." },
      { name: "Empowerment",     desc: "We are dedicated to empowering our people and our host community by creating an environment that encourages growth, creativity, innovation, and continuous learning." },
    ],
  },
};

const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${SERVER_ORIGIN}${url}`;
};

/* ═══════════════════════════════
   IMAGE UPLOAD FIELD
═══════════════════════════════ */
function ImageUploadField({ label, currentUrl, onUploaded }) {
  const [preview, setPreview]   = useState(resolveUrl(currentUrl) || null);
  const [uploading, setUploading] = useState(false);
  const [error, setError]       = useState(null);
  const inputRef = useRef();

  useEffect(() => { setPreview(resolveUrl(currentUrl) || null); }, [currentUrl]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    setError(null);
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("image", file);
      const res  = await fetch(UPLOAD_URL, { method: "POST", body: formData });
      const json = await res.json();
      if (!json.success) throw new Error(json.message || "Upload failed");
      onUploaded(json.url);
      setPreview(resolveUrl(json.url));
    } catch (err) {
      setError("Upload failed. Try again.");
      console.error("Upload error:", err);
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    onUploaded("");
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="editor-img-field">
      <label>{label}</label>
      {preview ? (
        <div className="editor-img-preview-wrap">
          <img src={preview} alt="preview" className="editor-img-preview" />
          {uploading && (
            <div className="editor-img-uploading">
              <div className="editor-loading__spinner editor-loading__spinner--sm" />
              <span>Uploading...</span>
            </div>
          )}
          {!uploading && (
            <div className="editor-img-actions">
              <button type="button" className="editor-img-btn editor-img-btn--change" onClick={() => inputRef.current?.click()}>Change</button>
              <button type="button" className="editor-img-btn editor-img-btn--remove" onClick={handleRemove}>Remove</button>
            </div>
          )}
        </div>
      ) : (
        <button type="button" className="editor-img-dropzone" onClick={() => inputRef.current?.click()} disabled={uploading}>
          {uploading
            ? <><div className="editor-loading__spinner editor-loading__spinner--sm" /><span>Uploading...</span></>
            : <><span className="editor-img-dropzone__icon">🖼️</span><span>Click to upload image</span><span className="editor-img-dropzone__hint">JPG, PNG, WEBP — max 10 MB</span></>
          }
        </button>
      )}
      {error && <p className="editor-img-error">{error}</p>}
      <input ref={inputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
    </div>
  );
}

/* ═══════════════════════════════
   EDIT MODAL
═══════════════════════════════ */
function EditModal({ data, onSave, onClose, saving }) {
  const [draft, setDraft] = useState(() => JSON.parse(JSON.stringify(data)));

  /* helpers */
  const setHero    = (i, f, v) => setDraft(d => { const s = [...d.heroSlides]; s[i] = { ...s[i], [f]: v }; return { ...d, heroSlides: s }; });
  const setService = (i, f, v) => setDraft(d => { const s = [...d.services]; s[i] = { ...s[i], [f]: v }; return { ...d, services: s }; });
  const setCvItem  = (i, f, v) => setDraft(d => { const items = [...d.coreValues.items]; items[i] = { ...items[i], [f]: v }; return { ...d, coreValues: { ...d.coreValues, items } }; });
  const addCvItem  = () => setDraft(d => ({ ...d, coreValues: { ...d.coreValues, items: [...d.coreValues.items, { name: "New Value", desc: "" }] } }));
  const removeCvItem = (i) => setDraft(d => { const items = d.coreValues.items.filter((_, idx) => idx !== i); return { ...d, coreValues: { ...d.coreValues, items } }; });

  return (
    <div className="editor-overlay" onClick={onClose}>
      <div className="editor-modal" onClick={e => e.stopPropagation()}>

        <div className="editor-modal__header">
          <h2>Edit Homepage Content</h2>
          <button className="editor-modal__close" onClick={onClose}>✕</button>
        </div>

        <div className="editor-modal__body">

          {/* ── HERO SLIDES ── */}
          <p className="editor-section__title">Hero Slides</p>
          {draft.heroSlides.map((slide, i) => (
            <div key={i} className="editor-group">
              <p className="editor-group__label">Slide {i + 1}</p>
              <label>Title</label>
              <input value={slide.title} onChange={e => setHero(i, "title", e.target.value)} />
              <ImageUploadField
                label="Background Image"
                currentUrl={slide.bg}
                onUploaded={url => setHero(i, "bg", url)}
              />
            </div>
          ))}

          {/* ── ANNOUNCEMENT ── */}
          <p className="editor-section__title">Announcement Banner</p>
          <div className="editor-group">
            <label>Banner Text</label>
            <textarea rows={2} value={draft.announcement} onChange={e => setDraft(d => ({ ...d, announcement: e.target.value }))} />
          </div>

          {/* ── ABOUT ── */}
          <p className="editor-section__title">About Section</p>
          <div className="editor-group">
            <label>Heading</label>
            <input value={draft.about.heading} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, heading: e.target.value } }))} />
            <label>Paragraph 1</label>
            <textarea rows={4} value={draft.about.paragraph1} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, paragraph1: e.target.value } }))} />
            <label>Paragraph 2</label>
            <textarea rows={3} value={draft.about.paragraph2} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, paragraph2: e.target.value } }))} />
            <label>Paragraph 3</label>
            <textarea rows={3} value={draft.about.paragraph3} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, paragraph3: e.target.value } }))} />
            <label>Stat — Man Hours Number</label>
            <input value={draft.about.statHours} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, statHours: e.target.value } }))} />
            <label>Stat — Man Hours Label</label>
            <input value={draft.about.statHoursLabel} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, statHoursLabel: e.target.value } }))} />
            <label>Stat — Projects Number</label>
            <input value={draft.about.statProjects} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, statProjects: e.target.value } }))} />
            <label>Stat — Projects Label</label>
            <input value={draft.about.statProjectsLabel} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, statProjectsLabel: e.target.value } }))} />
            <label>YouTube Embed URL</label>
            <input value={draft.about.videoUrl} onChange={e => setDraft(d => ({ ...d, about: { ...d.about, videoUrl: e.target.value } }))} placeholder="https://www.youtube.com/embed/..." />
            <ImageUploadField
              label="About Section Image"
              currentUrl={draft.about.image}
              onUploaded={url => setDraft(d => ({ ...d, about: { ...d.about, image: url } }))}
            />
          </div>

          {/* ── SERVICES ── */}
          <p className="editor-section__title">Services Section</p>
          <div className="editor-group">
            <label>Section Title</label>
            <input value={draft.servicesSection.title} onChange={e => setDraft(d => ({ ...d, servicesSection: { ...d.servicesSection, title: e.target.value } }))} />
          </div>
          {draft.services.map((svc, i) => (
            <div key={i} className="editor-group">
              <p className="editor-group__label">Service {i + 1}</p>
              <label>Title</label>
              <input value={svc.title} onChange={e => setService(i, "title", e.target.value)} />
              <label>Description</label>
              <textarea rows={3} value={svc.desc} onChange={e => setService(i, "desc", e.target.value)} />
              <label>Link (href)</label>
              <input value={svc.href} onChange={e => setService(i, "href", e.target.value)} />
            </div>
          ))}

          {/* ── CLIENTS ── */}
          <p className="editor-section__title">Clients Section</p>
          <div className="editor-group">
            <label>Section Title</label>
            <input value={draft.clientsSection.title} onChange={e => setDraft(d => ({ ...d, clientsSection: { ...d.clientsSection, title: e.target.value } }))} />
            <label>Subtitle</label>
            <textarea rows={4} value={draft.clientsSection.subtitle} onChange={e => setDraft(d => ({ ...d, clientsSection: { ...d.clientsSection, subtitle: e.target.value } }))} />
          </div>

          {/* ── CORE VALUES ── */}
          <p className="editor-section__title">Core Values Section</p>
          <div className="editor-group">
            <label>Section Label</label>
            <input value={draft.coreValues.label} onChange={e => setDraft(d => ({ ...d, coreValues: { ...d.coreValues, label: e.target.value } }))} />
            <label>Heading</label>
            <input value={draft.coreValues.heading} onChange={e => setDraft(d => ({ ...d, coreValues: { ...d.coreValues, heading: e.target.value } }))} />
          </div>
          <div className="editor-group">
            <p className="editor-group__label">Value Items</p>
            {draft.coreValues.items.map((item, i) => (
              <div key={i} style={{ display: "flex", flexDirection: "column", gap: 6, paddingBottom: 10, borderBottom: "1px solid #e5e7eb", marginBottom: 4 }}>
                <div className="editor-value-row">
                  <input placeholder="Value name" value={item.name} onChange={e => setCvItem(i, "name", e.target.value)} />
                  <button className="editor-value-row__remove" onClick={() => removeCvItem(i)} title="Remove">✕</button>
                </div>
                <textarea rows={3} placeholder="Description" value={item.desc} onChange={e => setCvItem(i, "desc", e.target.value)} style={{ width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 7, fontSize: 14, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
              </div>
            ))}
            <button className="editor-add-btn" onClick={addCvItem}>+ Add Value</button>
          </div>

        </div>

        <div className="editor-modal__footer">
          <button className="btn btn--ghost" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn btn--orange" onClick={() => onSave(draft)} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>

      </div>
    </div>
  );
}

/* ═══════════════════════════════
   SERVICE CARD
═══════════════════════════════ */
function ServiceCard({ icon, title, desc, href }) {
  return (
    <div className="service-card">
      <div className="service-card__icon">{icon}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <a href={href} className="btn btn--navy">Learn More</a>
    </div>
  );
}

/* ═══════════════════════════════
   HOMEPAGE
═══════════════════════════════ */
const Homepage = () => {
  const [pageData, setPageData]   = useState(DEFAULT_DATA);
  const [loading, setLoading]     = useState(true);
  const [fetchErr, setFetchErr]   = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving]       = useState(false);
  const [saveMsg, setSaveMsg]     = useState(null);
  const [current, setCurrent]     = useState(0);
  const [videoOpen, setVideoOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const intervalRef = useRef(null);
  const itemsPerView = 6;

  /* ── Fetch on mount ── */
  useEffect(() => { fetchPageData(); }, []);

  const fetchPageData = async () => {
    try {
      setLoading(true);
      setFetchErr(null);
      const res  = await fetch(API_BASE);
      const json = await res.json();
      if (json.success) setPageData(json.data);
      else throw new Error(json.message || "Failed to fetch");
    } catch (err) {
      console.error("Fetch error:", err);
      setFetchErr("Could not load page data. Using defaults.");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (draft) => {
    try {
      setSaving(true);
      const res  = await fetch(API_BASE, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(draft) });
      const json = await res.json();
      if (!json.success) throw new Error(json.message || "Save failed");
      await fetchPageData();
      setModalOpen(false);
      showToast("Changes saved successfully!");
    } catch (err) {
      console.error("Save error:", err);
      showToast("Save failed. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const showToast = (msg) => { setSaveMsg(msg); setTimeout(() => setSaveMsg(null), 3500); };

  /* ── Hero slider ── */
  const slides = pageData.heroSlides;
  const go = (n) => setCurrent((n + slides.length) % slides.length);
  useEffect(() => {
    const t = setInterval(() => setCurrent(c => (c + 1) % slides.length), 8500);
    return () => clearInterval(t);
  }, [slides.length]);

  /* ── Clients carousel ── */
  const totalSets = Math.ceil(clients.length / itemsPerView);
  const maxIndex  = totalSets - 1;
  const nextSlide = useCallback(() => setCurrentIndex(p => (p >= maxIndex ? 0 : p + 1)), [maxIndex]);
  const prevSlide = useCallback(() => setCurrentIndex(p => (p <= 0 ? maxIndex : p - 1)), [maxIndex]);
  useEffect(() => {
    if (isAutoPlaying) intervalRef.current = setInterval(nextSlide, 4000);
    return () => clearInterval(intervalRef.current);
  }, [isAutoPlaying, nextSlide]);

  /* ── Resolved assets ── */
  const slide      = slides[current] || slides[0];
  const getHeroBg  = (idx) => { const u = slides[idx]?.bg; return u ? resolveUrl(u) : (LOCAL_HERO_BGS[idx] || LOCAL_HERO_BGS[0]); };
  const aboutImage = resolveUrl(pageData.about?.image) || Avatar4;

  return (
    <>
      {/* Edit FAB */}
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg && <div className="editor-toast">{saveMsg}</div>}
      {loading && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && (
        <div className="editor-error-banner">
          {fetchErr}
          <button onClick={fetchPageData}>Retry</button>
        </div>
      )}
      {modalOpen && (
        <EditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} />
      )}

      {/* ── HERO ── */}
      <section className="hero" id="home">
        <div className="hero__bg" style={{ backgroundImage: `url(${getHeroBg(current)})` }} />
        <div className="hero__content">
          <h1>{slide.title}</h1>
          <p>{slide.sub}</p>
          <a href="#about" className="btn btn--orange">Read More</a>
        </div>
        <button className="hero__arrow hero__arrow--prev" onClick={() => go(current - 1)} aria-label="Previous slide">&#8249;</button>
        <button className="hero__arrow hero__arrow--next" onClick={() => go(current + 1)} aria-label="Next slide">&#8250;</button>
        <div className="hero__dots">
          {slides.map((_, i) => (
            <button key={i} onClick={() => go(i)} className={`hero__dot${i === current ? " hero__dot--active" : ""}`} aria-label={`Go to slide ${i + 1}`} />
          ))}
        </div>
      </section>

      {/* ── ANNOUNCEMENT ── */}
      <div className="announcement">
        <div className="announcement_carrier">
          <p>{pageData.announcement}</p>
          <a href="#about" className="btn btn--dark">Read More</a>
        </div>
      </div>

      {/* ── ABOUT ── */}
      <section
        className="section light_green"
        id="about"
        style={{ backgroundImage: `url(${Aboutbg})`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="welcome__grid">
          <div className="welcome__text">
            <h2>{pageData.about.heading}</h2>
            <p>{pageData.about.paragraph1}</p>
            <p>{pageData.about.paragraph2}</p>
            <p>{pageData.about.paragraph3}</p>
            <section className="stats-wrap">
              <div className="stat-block">
                <div className="stat-number">{pageData.about.statHours}</div>
                <div className="stat-label">{pageData.about.statHoursLabel}</div>
              </div>
              <div className="divider" aria-hidden="true" />
              <div className="stat-block">
                <div className="stat-number">{pageData.about.statProjects} <span className="accent">PROJECTS</span></div>
                <div className="stat-label">{pageData.about.statProjectsLabel}</div>
              </div>
            </section>
          </div>

          <div className="welcome__images">
            <img src={aboutImage} alt="Oilfield worker" />
            <button className="play-btn" onClick={() => setVideoOpen(true)}>
              <span className="play-btn__icon">
                <svg viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0 L10 6 L0 12 Z" />
                </svg>
              </span>
            </button>
          </div>

          {videoOpen && (
            <div className="video-modal-overlay" onClick={e => e.target === e.currentTarget && setVideoOpen(false)}>
              <div className="video-modal">
                <button className="video-modal__close" onClick={() => setVideoOpen(false)}>✕</button>
                <iframe
                  src={pageData.about.videoUrl}
                  allow="autoplay; encrypted-media; fullscreen"
                  allowFullScreen
                  title="Company Video"
                />
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="section section--light" id="services">
        <h2 className="section__title">{pageData.servicesSection.title}</h2>
        <div className="services__grid">
          {pageData.services.map((s, i) => (
            <ServiceCard key={i} icon={SERVICE_ICONS[i] || <FaWrench />} title={s.title} desc={s.desc} href={s.href} />
          ))}
        </div>
      </section>

      {/* ── CORE VALUES ── */}
      <section className="section section--navy" id="values">
        <div className="cv-section">
          <div className="cv-label">{pageData.coreValues.label}</div>
          <h2 className="cv-heading">{pageData.coreValues.heading}</h2>
          <div className="cv-grid">
            {pageData.coreValues.items.map((item, i) => (
              <div key={i} className="cv-item">
                <div className="cv-name">{item.name}</div>
                <div className="cv-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CLIENTS ── */}
      <section
        className="clients-section"
        onMouseEnter={() => setIsAutoPlaying(false)}
        onMouseLeave={() => setIsAutoPlaying(true)}
      >
        <h2 className="clients__title">{pageData.clientsSection.title}</h2>
        <p className="clients__subtitle">{pageData.clientsSection.subtitle}</p>
        <div className="clients__carousel">
          <button className="clients__arrow clients__arrow--prev" onClick={prevSlide}>‹</button>
          <div className="clients__viewport">
            <div className="clients__track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
              {clients.map((c, i) => (
                <div key={i} className="clients__card">
                  <img src={c.logo} alt={c.name} className="clients__logo-img" />
                </div>
              ))}
            </div>
          </div>
          <button className="clients__arrow clients__arrow--next" onClick={nextSlide}>›</button>
        </div>
        <div className="clients__dots">
          {Array.from({ length: totalSets }).map((_, i) => (
            <button
              key={i}
              className={`clients__dot ${i === currentIndex ? "clients__dot--active" : ""}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Homepage;
